export default __webpack_public_path__ + "static/media/AneomiOpen2.f5e76994.jpg";